import { useSelector } from 'react-redux';
import { resultsItems as resultsItemsSelector } from '@Pages/Results/selectors';

function useResultsItems() {
  return useSelector(resultsItemsSelector);
}

export default useResultsItems;
